/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from '../../../state'
import colors from '@sportninja/common/constants/appColors'
import pageIcon from './registration_submited.svg'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { EventDetails } from './Login'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import { useI18n } from '@shopify/react-i18n'
import dayjs from 'dayjs'

const getPositionName = (positionId) => {
  switch (positionId) {
    case 1:
      return 'Goalie'
    case 2:
      return 'Defense'
    case 3:
      return 'Forward'
    case 4:
      return 'Skater'
  }
}

export const RegistrationSubmitted = observer(() => {
  const {
    registrationInvite: {
      state: { submittedInfo, eventInfo },
    },
  } = useMobxStore()
  const history = useHistory()

  const [i18n] = useI18n()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
      `}
    >
      <img
        src={pageIcon}
        css={css`
          width: 234px;
          height: 252px;
          align-self: center;
        `}
      />
      <h1
        css={css`
          text-align: center;
          margin-top: 32px;
          font-size: 45px;
          font-weight: 700;
          font-family: ${isCanlan
            ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
            : 'Rift, Arial, Helvetica, sans-serif'};
        `}
      >
        {submittedInfo?.forcePayment ? 'Almost Done!' : 'Registration Submitted'}
      </h1>

      {submittedInfo?.forcePayment && (
        <div
          css={css`
            margin-top: 16px;
            max-width: 500px;
            align-self: center;

            p {
              text-align: center;
            }
          `}
        >
          <p>
            Now you need to pay the deposit amount in order to confirm your team
            registration.
          </p>
        </div>
      )}

      <div
        css={css`
          background-color: ${colors.LINK_WATER};
          padding: 16px;
          border-radius: 8px;
          margin: 32px 0;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            margin-bottom: 16px;
          `}
        >
          {submittedInfo?.teamImageUrl && (
            <img
              src={submittedInfo?.teamImageUrl}
              css={css`
                width: 36px;
                height: 36px;
                margin-right: 8px;
              `}
            />
          )}
          {submittedInfo?.teamName && (
            <p
              css={css`
                font-family: ${isCanlan
                  ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                  : 'Rift, Arial, Helvetica, sans-serif'};
                font-weight: 700;
                font-size: 36px;
                color: #27303e;
              `}
            >
              {submittedInfo?.teamName}
            </p>
          )}
        </div>
        <EventDetails label='Competition' value={eventInfo?.name} />
        {submittedInfo?.divisionName && (
          <EventDetails label='Division' value={submittedInfo.divisionName} />
        )}
        {submittedInfo?.costPerTeam && (
          <EventDetails
            label='Cost per team'
            value={i18n.formatCurrency(submittedInfo.costPerTeam, {
              currency: submittedInfo?.currency?.name,
              form: 'explicit',
            })}
          />
        )}
        {submittedInfo?.deposit && (
          <EventDetails
            label='Deposit'
            value={i18n.formatCurrency(submittedInfo.deposit, {
              currency: submittedInfo?.currency?.name,
              form: 'explicit',
            })}
          />
        )}

        {submittedInfo?.firstName && (
          <EventDetails
            label='Player'
            value={submittedInfo?.firstName + ' ' + submittedInfo?.lastName}
          />
        )}
        {submittedInfo?.position && (
          <EventDetails
            label='Position'
            value={getPositionName(submittedInfo?.position)}
          />
        )}
        {submittedInfo?.number && (
          <EventDetails label='Number' value={submittedInfo?.number} />
        )}
      </div>

      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        {!submittedInfo?.forcePayment && (
          <button
            onClick={() => history.push(ROUTES.HOME)}
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              margin-right: 8px;
              flex: 1;
              height: 40px;
              border: 2px solid #3f4753;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            BACK TO HOME
          </button>
        )}
        {!submittedInfo.firstName && (
          <button
            onClick={() =>
              history.push(
                `${ROUTES.REGISTRATION_PAYMENT}?divisionId=${submittedInfo.divisionId}&teamId=${submittedInfo.teamId}`
              )
            }
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              margin-left: 8px;
              color: white;
              flex: 1;
              height: 40px;
              background: ${colors.DEFAULT_FLAIR};
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            {submittedInfo?.forcePayment ? 'PAY DEPOSIT NOW' : 'PAY DEPOSIT'}
          </button>
        )}
      </div>

      {submittedInfo?.billingInfo && (
        <>
          <div
            css={css`
              margin-top: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            `}
          >
            <p
              css={css`
                font-family: ${isCanlan
                  ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                  : 'Rift, Arial, Helvetica, sans-serif'};
                font-weight: 700;
                font-size: 28px;
                color: #27303e;
                text-align: center;
              `}
            >
              Payment Schedule (Installments)
            </p>
            <div
              css={css`
                margin-top: 16px;
                display: flex;
                flex-direction: column;
                width: 100%;
              `}
            >
              {submittedInfo?.billingInfo.map((billing, index) => {
                if (billing.payment_type !== 'deposit') {
                  return (
                    <div
                      key={billing?.uid}
                      css={css`
                        display: flex;
                        align-items: center;
                        margin: 6px 0;
                      `}
                    >
                      <div
                        css={css`
                          flex: 1;
                        `}
                      />
                      <p
                        css={css`
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 700;
                          color: #27303e;
                          flex: 0.9;
                        `}
                      >
                        Payment {index}
                      </p>
                      <p
                        css={css`
                          margin-left: 16px;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 500;
                          color: #27303e;
                          flex: 2;
                        `}
                      >
                        {i18n.formatCurrency(billing?.amount, {
                          currency: submittedInfo?.currency?.name,
                          form: 'short',
                        })}{' '}
                        due {dayjs(billing?.due_date).format('DD MMM YYYY')}
                      </p>
                      <div
                        css={css`
                          flex: 1;
                        `}
                      />
                    </div>
                  )
                }
              })}
            </div>
          </div>
          <div
            css={css`
              margin-top: 16px;
              display: flex;
              justify-content: center;
            `}
          >
            <p
              css={css`
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                color: ${colors.ATTENDANCE_GRAY};
              `}
            >
              All monthly payments will now be paid online.
            </p>
          </div>
        </>
      )}
    </div>
  )
})
